import { Component, Input } from '@angular/core';

@Component({
  selector: 'opac-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent {
  private _progress = 0;

  @Input() progressText: string;
  @Input() set progress(value: number) {
    this._progress = value;
    this.progressText = this.progressText ?? '';
  }
  get progress(): number {
    return this._progress;
  }

  clamp(a: number, min = 0, max = 1) {
    return Math.min(max, Math.max(min, a));
  }
}
